export default {
  red: '#E74C3C',
  green: '#2ECC71',
  yellow: '#F39C12',
  yellow2: '#D68910',
  regular: '#ccc',
  darkBlue: '#2f3640',
  lightWhite: '#f5f6fa',
  lightGray: '#666666'
}
